import styled from "styled-components";
import {LiveCasinoGridDefaultBox} from "./live-casino-grid.default.box";

export const LiveCasinoGridMrGreenBox = styled(LiveCasinoGridDefaultBox)`
    &:before {
        background-image: none;
    }
`;